import { ActionTree } from 'vuex';
import { IDocumentSettingsState } from '../stores/document-settings.store';
import { RootState } from '../store';
import { mutationSetSettings } from '../mutations/document-settings.mutations';
import { getFieldName, postSetting, getFieldValue } from '@/services/document-settings.service';
import { IDocumentSettings } from '@/types/DocumentSettings';

export const actionSetSettings = 'setSettings';
export const actionEditSetting = 'editSetting';

export const actions: ActionTree<IDocumentSettingsState, RootState> = {
  async [actionSetSettings]({ commit }, payload: IDocumentSettings) {
    commit(mutationSetSettings, payload);
  },
  async [actionEditSetting](
    { commit, state },
    { entityId, setting }: { entityId: string; setting: {} }
  ): Promise<boolean> {
    const key = Object.keys(setting)[0];
    const value = setting[key];

    if (value === null || value === undefined) {
      return false;
    }

    const originalValue = state.settings[key];
    const newSettings: IDocumentSettings = { ...state.settings, [key]: value };
    commit(mutationSetSettings, newSettings);

    const fieldName = getFieldName(key.toString());
    if (!fieldName) {
      console.error('Could not find field name for', key);
      commit(mutationSetSettings, { ...state, [key]: originalValue });
      return false;
    }
    const payload = new FormData();
    payload.append('action', 'entity');
    payload.append('id', entityId);
    payload.append('field', fieldName);
    payload.append('value', getFieldValue(value));

    const status: number = await postSetting(payload);
    if (status !== 1) {
      commit(mutationSetSettings, { ...state, [key]: originalValue });
      return false;
    }
    return true;
  },
};
